export class CustomFilter {
  public linkType?: number;
  public items?: CustomFilter[];
  public fieldName?: String;
  public fieldType?: String;
  public operator?: number;
  public values?: String [] = [];

}
